const configuredBaseUrl = String(process.env.REACT_APP_API_URL || "").trim();

// A production build is created only after scripts/require-cra-api-url.js has
// validated this value. Local development derives its local API origin only
// outside a production bundle.
const developmentFallback =
  process.env.NODE_ENV !== "production" && typeof window !== "undefined"
    ? `${window.location.protocol}//${window.location.hostname}:4000`
    : "";

export const API_BASE_URL = (configuredBaseUrl || developmentFallback).replace(/\/+$/, "");

export function apiUrl(path = "") {
  const value = String(path || "").trim();
  if (!value) return API_BASE_URL;
  if (/^https?:\/\//i.test(value)) return value;
  return `${API_BASE_URL}/${value.replace(/^\/+/, "")}`;
}
